export class AdminConvertLeadPayload {}